<template>
  <div id="form" class="modal with-header white" ref="modal">
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title">
          Create Record
        </div>
        <ul class="right">
          <li>
            <a class="">
              <i class="material-icons grey-text text-darken-3">minimize</i>
            </a>
          </li>
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade-in">
   
   <div class="modal-content grey lighten-4" v-if="ready">
    <div class="form-fields">
      <div 
      :class="field.layout"
      v-for="(field, index) in fields" v-bind:key="index">
        <field-types
          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event)"
          :data-option="field"
        >
        </field-types>
      </div>
    </div>
     <div>
     </div>
   </div>
    </transition>
   <div class="loader-container" v-if="!ready">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left">
      <p style="margin:0px;">
        <label>
          <input v-model="notify"  type="checkbox" />
          <span>Send Notification</span>
        </label>
      </p>
      </div>
      <button
        :disabled="sending || !validateForm"
        @click="$_saveCheck()"
        class="btn z-depth-0 right">
        Save Record
      </button>
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Cancel
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component'
import recordFields from '@/components/records/form/records-incoming'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
export default {
  name:'formView',
  components:{
    fieldTypes,
  },
  data(){
    let vm = this
    return {
     // fields:recordFields.fields,
      curr_index:0,
      notify:false,
      post: new Object,
      sending:false,
      fullScreen:false,
      ready:false,
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
            vm.$_checkId()
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
  },
  mounted(){   
    this.$_vModal()
    this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)         
  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
      records:state => state.record.records,

    }),
    fields:{
      get(){
        return recordFields.generate()
      }
    },
    validateForm:{
      get(){
        return this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods:{
    $_checkId(){
      contentService.checkMostRecentRecord()
      .then(res=>{
        const refId = res.data.length > 0 ? res.data[0].acf.id : 0
        const record = this.fields.find(item => item.name === 'id')
        record.values = parseInt(refId) + 1 
        const nameRecord = this.fields.find(item => item.name === 'name')
        nameRecord.values = `${record.values}/${moment(new Date()).format('YY')}`
        setTimeout(() => {
          this.ready = true 
        }, 400);
      })
    },
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
    $_filesToUpload($event){
      window.console.log($event)
      this.uploads.data = $event.data
    },
    $_processFiles(){
      const count =  {
          promises:promises.length,
          sucess:0,
          files:new Array,
      }
      let promises = this.uploads.data.map(item => contentService.uploadFile(item))
      Promise.all(promises)
        .then(res=>{         
         count.sucess = count.sucess + 1
         count.files.push({file:res[count.sucess - 1].data.id})
         if(count.promises === count.sucess) {
            window.console.log('uploadDone')          
          }        
        })
    },
    $_fieldsData($event){
        const record =  this.fields.find(item => item.name === $event.name)
        if(record){
          
          if(record.name === 'from' || record === 'to')
          record.values = $event.data
          else 
          record.values = $event.data
        } 
        this.post = this.$_postStructure()
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
    $_editValues($event){
      let payload = {
        action:'update_field_values',
        uid:$event.field,
        data:$event.values
      }
      this.$store.commit('ADD_FIELDS_DATA', payload)
    },
    $_sendNotificaiton(data){
      let fromUser = this.users.find(user => user.id === parseInt(data.acf.from))
      let toUser = this.users.find(user => user.id === parseInt(data.acf.to))
      let payload = {
        from:fromUser.acf.first_name +' '+ fromUser.acf.last_name,
        to:toUser.acf.first_name +' '+toUser.acf.last_name,
        record:data.acf.id,
        routeuser:toUser.acf.email,
        message:`New record created by user see below for details`,
        url:`https://docs.eccourts.org/records/record/view/${data.id}`,
      }
      formService.newRecord(payload)
      .then(res =>{ 
        window.console.log(res)
      })
    },
    $_postStructure(){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : ''
        }
        return {
          id:mapValue('id'),
          name:mapValue('name'),
          subject:mapValue('subject'),
          type:mapValue('type'),
          category:mapValue('category'),
          date_stamp:mapValue('date_stamp'),
          date_corres:mapValue('date_corres'),
          comments:mapValue('comments'),
          stamps:mapValue('stamps'),
          notes:mapValue('notes'),
          from:mapValue('from').id,
          contents:mapValue('contents'),
          routes:mapValue('routes'),
          to:mapValue('to').id,
          attachments:this.uploads.ready ? this.uploads.added.map(item=> item.id) : []
        }
    },
    $_saveCheck(){
      this.ready = false
      this.sending = true
      contentService.checkMostRecentRecord()
      .then(res=>{
        const refId = res.data.length > 0 ? res.data[0].acf.id : 0
        const record = this.fields.find(item => item.name === 'id')
        record.values = parseInt(refId) + 1
        const nameRecord = this.fields.find(item => item.name === 'name')
        nameRecord.values = `${record.values}/${moment(new Date()).format('YY')}`
        setTimeout(() => {
          this.$_saveRecord()
        }, 300);
      })
      .catch(err =>{
      
        if(err)
        core.toastMessage('Opps error please try again later')
        this.ready = true
      })
    },
    $_saveRecord(){
      
      const post = this.post
      const structure = {
        title:post.name,
        status:'publish',
        fields:{
          ...this.post
        }
      }
     contentService.saveRecord(structure)
      .then(res=>{
        core.toastMessage('Record Added Successfully <a style="margin-left:6px; " class="little-link yellow-text text-darken-2"> View Record</a>', ()=>{ })
          setTimeout(() => {
            let element = document.querySelector('.little-link')
             element.addEventListener('click', ()=>{
              this.$router.replace({name:'view_record', params:{id:res.data.id}})
               
            }, {passive:true})
          }, 300); 
        this.$store.commit('ADD_RECORD', res.data)

        //this.modal.instance.close()
        this.notify 
        ? this.$_sendNotificaiton(res.data)
        : false

        this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)
        this.post = new Object
       
        this.$_checkId()
        setTimeout(() => {
          this.ready = true
          this.sending = false
        }, 600);
    //this.modal.instance.destroy()
    //this.$_vModal()
    //this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)   
      })   
    },
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 22px;
        display: inline;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}

}
</style>
<style lang="scss">

#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
}
</style>